import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//获取modules目录下的文件名称列表
const modulesFiles = require.context('./modules', true, /\.js$/);

//用文件名构造模块对象
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  modules
});

export function loadModuleStore(moduleName, moduleStore) {
  if (!moduleName) {
    return;
  }
  if (!moduleStore) {
    return;
  }
  // 注册模块 名字按照module文件夹名称命名
  store.registerModule(moduleName, moduleStore);
}

export default store;